import React from 'react';
export function Footer() {
  return <footer className="bg-teal-950 text-teal-100 py-10 md:py-16 px-4 md:px-8 border-t border-teal-900 pb-24 md:pb-16" data-id="element-113">
      <div className="max-w-5xl mx-auto flex flex-col md:flex-row justify-between items-center md:items-start gap-6 md:gap-8 text-center md:text-left" data-id="element-114">
        <div className="max-w-md" data-id="element-115">
          <h3 className="text-white font-serif font-bold text-base md:text-xl mb-3 md:mb-4 flex items-center justify-center md:justify-start gap-2 leading-tight" data-id="element-116">
            <span data-id="element-117">🩺</span> KIT DE EVALUACIÓN FONOAUDIOLÓGICA INFANTIL™
          </h3>
          <p className="text-teal-200/80 text-xs md:text-sm leading-relaxed mb-4 md:mb-6" data-id="element-118">
            El sistema clínico N°1 para fonoaudiólogas en consulta privada con
            niños en Argentina. Porque evaluar con seguridad no debería costarte
            horas de improvisación ni noches de dudas.
          </p>
        </div>

        <div className="flex flex-col gap-1.5 md:gap-2 text-xs md:text-sm font-medium" data-id="element-119">
          <a href="mailto:contacto@solucionesya.shop" className="hover:text-white transition-colors" data-id="element-120">
            contacto@solucionesya.shop
          </a>
          <a href="#" className="hover:text-white transition-colors" data-id="element-121">
            @solucionesya.shop
          </a>
          <a href="#" className="hover:text-white transition-colors" data-id="element-122">
            solucionesya.shop
          </a>
        </div>
      </div>

      <div className="max-w-5xl mx-auto mt-8 md:mt-12 pt-6 md:pt-8 border-t border-teal-900/50 text-center text-[10px] md:text-xs text-teal-400/60" data-id="element-123">
        © solucionesya.shop™ 2026 — Todos los derechos reservados.
      </div>
    </footer>;
}